import { ApolloLink } from "@apollo/client";
import createDirectivesCleanupLink from "./createDirectivesCleanupLink";
import createObservabilityLink from "./createObservabilityLink";
import createRouteToTestOrRealSchemaLink from "./createRouteToTestOrRealSchemaLink";
import createSchemaLinksConfiguration from "./createSchemaLinksConfiguration";
import createComponentKillswitchLink from "../../../public/links/createComponentKillswitchLink";
import createKillswitchLink from "../../../public/links/createKillswitchLink";
export default function createApolloLink(schemas, observabilityFns) {
    const schemaLinksConfiguration = createSchemaLinksConfiguration(schemas, observabilityFns);
    return ApolloLink.from([
        createObservabilityLink(),
        createDirectivesCleanupLink(),
        createKillswitchLink(),
        createComponentKillswitchLink(),
        createRouteToTestOrRealSchemaLink(schemaLinksConfiguration)
    ]);
}

//# sourceMappingURL=createApolloLink.js.map